import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/Home/HomeView.vue'
import HomeViewFA from '../views/Home/HomeViewFA.vue'

let routes: Array<RouteRecordRaw> = []

if (localStorage.getItem('lang') == null) {
  localStorage.setItem('lang','fa')
}

if (localStorage.getItem('lang')=='fa') {
  const Testroutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeViewFA
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/About/AboutViewFA.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/Contact/ContactViewFA.vue')
  },
  {
    path: '/blogs',
    name: 'blogs',
    component: () => import('../views/Blog/BlogsViewFA.vue')
  },
  {
    path: '/blog/:url',
    name: 'blog',
    component: () => import('../views/Blog/BlogDetailesFA.vue')
  },
  {
    path: '/product',
    name: 'product',
    component: () => import('../views/Product/ProductsFA.vue')
  },
  // {
  //   path: '/product-single/:id/:id2/:id3',
  //   name: 'product-single',
  //   component: () => import('../views/ProductSingle.vue')
  // },
  {
    path: '/product-single',
    name: 'product-single',
    component: () => import('../views/Product/ProductSingleFA.vue')
  },
  {
    path: '/demo',
    name: 'demo',
    component: () => import('../views/Demo/DemoViewFA.vue')
  },
  {
    path: '/text-analysis',
    name: 'text-analysis',
    component: () => import('../views/Demo/TextAnalysisFA.vue')
  },
  {
    path: '/voice-analysis',
    name: 'voice-analysis',
    component: () => import('../views/Voice/voiceFA.vue')
  },
  {
    path: '/image-analysis',
    name: 'image-analysis',
    component: () => import('../views/Video/videoFA.vue')
  },
  {
    path: '/portfolio-managment',
    name: 'portfolio-managment',
    component: () => import('../views/portfolioManagement.vue')
  },
  {
    path: '/price-prediction',
    name: 'price-prediction',
    component: () => import('../views/PricePrediction.vue')
  },
  {
    path: '/churn-prediction',
    name: 'churn-prediction',
    component: () => import('../views/ChurnPrediction.vue')
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/Profile.vue')
  },
  {
    path: '/faq',
    name: 'faq',
    component: () => import('../views/FAQPage.vue')
  },
  {
    path: '/book-a-demo',
    name: 'book-a-demo',
    component: () => import('../views/BookDemo.vue')
  },
  {
    path: '/transaction-history',
    name: 'transaction-history',
    component: () => import('../views/TransactionHistory.vue')
  },
  {
    path: '/increase-credit',
    name: 'increase-credit',
    component: () => import('../views/IncreaseCredit.vue')
  },
  {
    path: '/sign-up',
    name: 'sign-up',
    component: () => import('../views/Signup.vue')
  },
  {
    path: '/sign-in',
    name: 'sign-in',
    component: () => import('../views/Signin.vue')
  },
  {
    path: '/404',
    name: '404',
    component: () => import('../views/404/404.vue')
  },
]
routes = Testroutes
}
else{
  const Testroutes: Array<RouteRecordRaw> = [
    {
      path: '/',
      name: 'home',
      component: HomeView
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../views/About/AboutView.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('../views/Contact/ContactView.vue')
    },
    {
      path: '/blogs',
      name: 'blogs',
      component: () => import('../views/Blog/BlogsVeiw.vue')
    },
    {
      path: '/blog/:url',
      name: 'blog',
      component: () => import('../views/Blog/BlogDetailes.vue')
    },
    {
      path: '/product',
      name: 'product',
      component: () => import('../views/Product/Products.vue')
    },
    // {
    //   path: '/product-single/:id/:id2/:id3',
    //   name: 'product-single',
    //   component: () => import('../views/ProductSingle.vue')
    // },
    {
      path: '/product-single',
      name: 'product-single',
      component: () => import('../views/Product/ProductSingle.vue')
    },
    {
      path: '/demo',
      name: 'demo',
      component: () => import('../views/Demo/DemoView.vue')
    },
    {
      path: '/text-analysis',
      name: 'text-analysis',
      component: () => import('../views/Demo/TextAnalysis.vue')
    },
    {
      path: '/voice-analysis',
      name: 'voice-analysis',
      component: () => import('../views/Voice/voice.vue')
    },
    {
      path: '/image-analysis',
      name: 'image-analysis',
      component: () => import('../views/Video/video.vue')
    },
    {
      path: '/portfolio-managment',
      name: 'portfolio-managment',
      component: () => import('../views/portfolioManagement.vue')
    },
    {
      path: '/price-prediction',
      name: 'price-prediction',
      component: () => import('../views/PricePrediction.vue')
    },
    {
      path: '/churn-prediction',
      name: 'churn-prediction',
      component: () => import('../views/ChurnPrediction.vue')
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('../views/Profile.vue')
    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import('../views/FAQPage.vue')
    },
    {
      path: '/book-a-demo',
      name: 'book-a-demo',
      component: () => import('../views/BookDemo.vue')
    },
    {
      path: '/transaction-history',
      name: 'transaction-history',
      component: () => import('../views/TransactionHistory.vue')
    },
    {
      path: '/increase-credit',
      name: 'increase-credit',
      component: () => import('../views/IncreaseCredit.vue')
    },
    {
      path: '/sign-up',
      name: 'sign-up',
      component: () => import('../views/Signup.vue')
    },
    {
      path: '/sign-in',
      name: 'sign-in',
      component: () => import('../views/Signin.vue')
    },
    {
      path: '/404',
      name: '404',
      component: () => import('../views/404/404.vue')
    },
  ]
  routes = Testroutes
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
